import {defineStore} from 'pinia';
import API from '@/shared/helpers/API.js';
import {useUserStore} from "@/console-new/stores/user.store";
import {useNotificationStore} from "@/shared/stores";

export const useExperiencesStore = defineStore('experiences', {
	state: () => ({
		businessExperiences: null,
		editElementsId: null,
		editScheduleId: null,
		editInfoId: null,
	}),
	getters: {
		hasExperiences: state => {
			return state.businessExperiences && state.businessExperiences.length > 0;
		}
	},
	actions: {
		getBusinessExperiences(callback = null, force = false) {
			if(this.businessExperiences != null && !force) { callback && callback(this.businessExperiences); return; }

			let userStore = useUserStore();
			if(!userStore.currBusinessId) { return; }
			API.init().getExperiences(userStore.currBusinessId, response => {
				if (response && response.result === "OK") {
					if(response.experiences && response.experiences.length > 0) {
						this.businessExperiences = this.normalizeExperiences(response.experiences, response.experiences_tables);
					} else {
						this.businessExperiences = [];
					}
					callback && callback(this.businessExperiences);
				}
			});
		},
		saveBusinessExperiences(callback = null) {
			let userStore = useUserStore();
			if(!userStore.currBusinessId) { return; }

			const withNew = this.businessExperiences.filter(e => e.experience_id.startsWith('newexperience'));

			API.init().saveExperiences(userStore.currBusinessId, JSON.stringify(this.businessExperiences), response => {
				const notificationStore = useNotificationStore();
				if (response && response.result === "OK") {
					if(withNew.length > 0) {
						this.getBusinessExperiences(() => {
							callback && callback(this.businessExperiences);
							notificationStore.showNotification('generic-success');
						}, true);
					} else {
						callback && callback(this.businessExperiences);
						notificationStore.showNotification('generic-success');
					}
				} else {
					notificationStore.showNotification('generic-fail');
				}
			});

		},
		saveExperienceTables(experienceId, tables, callback = null) {
			let userStore = useUserStore();
			if(!userStore.currBusinessId) { return; }

			API.init().saveExperienceTables(userStore.currBusinessId, experienceId, JSON.stringify(tables), response => {
				const notificationStore = useNotificationStore();
				if (response && response.result === "OK") {
					callback && callback(tables);
					notificationStore.showNotification('generic-success');
				} else {
					notificationStore.showNotification('generic-fail');
				}
			});
		},
		saveExperienceSchedule(experienceId, timeslots, schedule, callback = null) {
			let userStore = useUserStore();
			if(!userStore.currBusinessId) { return; }

			API.init().saveExperienceSchedule(userStore.currBusinessId, experienceId, JSON.stringify(timeslots), response => {
				const notificationStore = useNotificationStore();
				if (response && response.result === "OK") {
					callback && callback(schedule);
					notificationStore.showNotification('generic-success');
				} else {
					notificationStore.showNotification('generic-fail');
				}
			});
		},
		addNewExperience() {
			this.businessExperiences.push({
				experience_id: 'newexperience'+Math.random(),
				name: '',
				description: '',
				price: 0,
				color: '#0752A3',
				picture: null,
				slug: null,
				active: true,
				activeDropdown: true,
				info_dogs: false,
				info_children: false,
				info_special: false,
				info_allergens: false,
				days_advance: 30,
				limit_people: null,
				tables: [],
				timeslots: [],
				exceptions: [],
				deleted: false
			});
		},
		normalizeExperiences(experiences, tables) {

			let tablesMap = {};
			tables.forEach(table => {
				if(!tablesMap.hasOwnProperty(table.experience_id)) {
					tablesMap[table.experience_id] = [];
				}
				tablesMap[table.experience_id].push(table);
			});

			return experiences.map(experience => {
				experience.experience_id = experience.experience_id ? experience.experience_id+"" : null;
				experience.price = parseInt(experience.price);
				experience.active = experience.active === 1;
				experience.info_dogs = experience.info_dogs === 1;
				experience.info_children = experience.info_children === 1;
				experience.info_special = experience.info_special === 1;
				experience.info_allergens = experience.info_allergens === 1;
				experience.days_advance = experience.days_advance ? parseInt(experience.days_advance) : 30;
				experience.limit_people = experience.limit_people !== null && experience.limit_people !== undefined ? parseInt(experience.limit_people) : null;
				experience.picture = experience.picture ? experience.picture : null;
				experience.slug = experience.slug ? experience.slug : null;
				experience.deleted = false;
				experience.tables = [];
				if (tablesMap.hasOwnProperty(experience.experience_id)) {
					experience.tables = tablesMap[experience.experience_id];
				}
				experience.timeslots = [];
				experience.exceptions = [];
				return experience;
			});
		},
		normalizeTimeslot(t) {

			let startTime = t.time_start.split(":");
			if(startTime.length >= 2) {
				startTime = startTime[0] + ":" + startTime[1];
			}
			let endTime = t.time_end.split(":");
			if(endTime.length >= 2) {
				endTime = endTime[0] + ":" + endTime[1];
			}
			return {
				experience_timeslot_id: t.experience_timeslot_id ? t.experience_timeslot_id : null,
				name: t.name,
				price: t.price ? Number(t.price) : null,
				start: startTime,
				end: endTime,
				weekday: Number(t.weekday),
				time: Number(t.duration),
				intervals: Number(t.intervals),
				dontRequestCard: t.no_card === 1,
			}
		},
		getUniqueSlug(experienceId, slug) {
			let result = slug;
			while(Object.values(this.businessExperiences).find(m => m.slug === result && m.experience_id !== experienceId)) {
				result += "-1";
			}
			return result;
		},
		getExperienceById(experienceId) {
			if(!this.businessExperiences) { return null; }
			return this.businessExperiences.find(e => Number(e.experience_id) === experienceId);
		},
	}
});
